import Crud from '../views/Unidade/Crud'
import Entity from '../views/Unidade/Add'

let routes = {
    path: '/unidades',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/unidades/add',
            name: 'NewUnidade',
            component: Entity
        },
        {
            path: '/unidades/edit/:id?',
            name: 'EditUnidade',
            component: Entity
        },
        {
            path: '/unidades',
            name: 'list-unidades',
            component: Crud,
            meta: {
                pageTitle: '',
                breadcrumb: [
                    {
                        text: 'Unidades',
                        active: true,
                    },
                ],
            },
        },
    ]
};


export default routes
